"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryApplicationKeys = void 0;

var _common = require("./../common");

var _service = require("./../service");

var _CrudBuilder = require("./../service/CrudBuilder");

const BasisTheoryApplicationKeys = new _CrudBuilder.CrudBuilder(class BasisTheoryApplicationKeys extends _service.BasisTheoryService {
  create(applicationId) {
    return this.client.post(`${applicationId}/keys`).then(_common.dataExtractor);
  }

  get(applicationId) {
    return this.client.get(`${applicationId}/keys`).then(_common.dataExtractor);
  }

  getById(applicationId, keyId) {
    return this.client.get(`${applicationId}/keys/${keyId}`).then(_common.dataExtractor);
  }

  delete(applicationId, keyId) {
    return this.client.delete(`${applicationId}/keys/${keyId}`).then(_common.dataExtractor);
  }

}).build();
exports.BasisTheoryApplicationKeys = BasisTheoryApplicationKeys;